<template>
  <v-container fluid>
    <v-row>
      <v-col class="text-h3 gray--text">
        Exames
      </v-col>
    </v-row>

    <v-row v-for="(filteredExams, examName) in groupedExams" :key="examName">
      <v-col>
        <v-row dense>
          <v-col class="text-h5 gray--text text--lighten-1">
            {{ examName }}
          </v-col>
        </v-row>

        <v-row dense v-for="(exam, index) in filteredExams" :key="exam.id">
          <v-col>
            <ExamListItem
              :exam="exam"
              :index="index"
              :allowEdit="false"
              :allowDelete="false"
              :forcePrint="true"
            />
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import ExamListItem from "@/components/exam/list/item.vue";

  export default {
    name: "Exams",
    props: {
      patient: Object,
    },
    components: {
      ExamListItem,
    },
    apollo: {
      examsPatient: {
        query: require("@/graphql/exam/exams_patient.gql"),
        variables() {
          return {
            patientId: this.patient.id,
          };
        },
        pollInterval: 20000,
      },
    },
    computed: {
      groupedExams() {
        const unordered = this.lodash.groupBy(this.examsPatient, "examTemplate.name");
        const ordered = {};
        Object.keys(unordered)
          .sort()
          .forEach(function(key) {
            ordered[key] = unordered[key];
          });
        return ordered;
      },
    },
  };
</script>

<style lang="scss" scoped></style>
